import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semobold py-4 fs-6 w-auto",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/avatars/blank.png"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bold d-flex align-items-center fs-5" }
const _hoisted_7 = {
  href: "#",
  class: "fw-semobold text-muted text-hover-primary fs-7"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_10 = { class: "menu-title position-relative" }
const _hoisted_11 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "symbol symbol-20px me-4" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "menu-item px-5 my-1" }
const _hoisted_18 = { class: "menu-item px-5 my-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_20 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userInfo["name"]), 1),
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.userInfo["email"]), 1)
        ])
      ])
    ]),
    _hoisted_8,
    (Object.keys(_ctx.GlobalConfig.siteLanguages).length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "#",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t("LANGUAGE")) + " ", 1),
                _createElementVNode("span", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
                  _createElementVNode("img", {
                    class: "w-15px h-15px rounded-1 ms-2",
                    src: '/media/flags/'+_ctx.currentLangugeLocale.flag,
                    alt: "metronic"
                  }, null, 8, _hoisted_12)
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GlobalConfig.siteLanguages, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.short_code,
                class: "menu-item px-3"
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.setLang(item.short_code)),
                  href: "#",
                  class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(item.short_code) }])
                }, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "rounded-1",
                      src: '/media/flags/'+item.flag,
                      alt: "metronic"
                    }, null, 8, _hoisted_16)
                  ]),
                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                ], 10, _hoisted_14)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: 'my-profile',
          })
        )),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("MY_PROFILE")), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.$router.push({
            name: 'change-password',
          })
        )),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("CHANGE_PASSWORD")), 1)
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("SIGN_OUT")), 1)
    ])
  ]))
}